import {Cell} from 'notebook/tables/constants/CellConstants';

import {LiveCellValue} from '../LiveCellValues';

/**
 * A cell's "initial value" is the value it should take
 * when it is added to a table. The initial value
 * overrides the default value of the cell's column.
 *
 * A cell's initial value is always optional.
 * If no initial value is available when adding a cell,
 * the cell's contents will be initialized using some other mechanism.
 * For example, the cell could be blank, or it could be initialized using
 * its column's default value.
 */
export type InitialCellValue = Cell | null;

/**
 * Get the "initial value" of a cell given its live cell value.
 *
 * @returns a {@type InitialCellValue} matching the live cell value,
 * or null if there is no live cell value available.
 */
export default function getInitialCellValueFromLiveValue(liveCellValue: LiveCellValue): InitialCellValue {
  if (liveCellValue === 'NO_VALUE') {
    return null;
  } else if (liveCellValue == null) {
    // If live cell value is present but blank, initialize the cell to blank,
    // even if the column has a default value.
    return {text: ''};
  } else {
    return {text: '', typedValue: liveCellValue};
  }
}
